export type StatusInfo = {
  label: string;
  colorScheme: string;
  tagLabel: string;
};

export const statusInfoMap: Record<string, StatusInfo> = {
  PENDING: {
    label: "Aguardando Caixa",
    colorScheme: "yellow.400",
    tagLabel: "Tente novamente em 5 minutos.",
  },
  SUCCESS: {
    label: "Consulta Concluída",
    colorScheme: "#85c773",
    tagLabel: "Sua consulta foi realizada com sucesso.",
  },
  NO_BALANCE: {
    label: "Saldo Insuficiente",
    colorScheme: "#FF0000",
    tagLabel: "Você não possui saldo mínimo para realizar a antecipação.",
  },
  NO_ACCOUNT: {
    label: "Aviso Importante!",
    colorScheme: "#FF0000",
    tagLabel: "Você não possui conta no FGTS.",
  },
  INVALID_PERIOD: {
    label: "Aviso Importante!",
    colorScheme: "#FF0000",
    tagLabel: " Tente novamente em 5 minutos.",
  },
  NOT_AUTHORIZED: {
    label: "Aviso Importante!",
    colorScheme: "#FF0000",
    tagLabel: " A CAIXA informou que não é possível realizar a consulta para o CPF informado.",
  },
  ONGOING_FIDUCIARY_OPERATION: {
    label: "Aviso Importante!",
    colorScheme: "#FF0000",
    tagLabel: "Você já está antecipando em outra plataforma.",
  },
  WORKER_NOT_ADHERED_TO_BIRTHDAY_WITHDRAWAL: {
    label: "Aviso Importante!",
    colorScheme: "#FF0000",
    tagLabel: "Voltou ao Saque Recisão. A modalidade correta deve ser Saque Aniversário.",
  },
  OPERATION_NOT_ALLOWED_BEFORE_DATE: {
    label: "Aviso Importante!",
    colorScheme: "#FF0000",
    tagLabel: "Está próximo do seu aniversário. A operação não será permitida antes desta data: DD-MM-AAAA.",
  },
  OPERATION_NOT_ALLOWED_DUE_TO_PENDING_PAYMENT: {
    label: "Aviso Importante!",
    colorScheme: "#FF0000",
    tagLabel: "A CAIXA informa sobre uma pendência no pagamento do saque-aniversário. Por favor, se dirija a uma agência da CAIXA.",
  },
  WORKER_MUST_CANCEL_RETURN_REQUEST: {
    label: "Aviso Importante!",
    colorScheme: "#FF0000",
    tagLabel: "Você solicitou o retorno para a modalidade de Saque Rescisão. Volte à modalidade de Saque-Aniversário para seguir com a contratação. Tente novamente em 5 minutos.",
  },
  ACCOUNT_CHANGES_PREVENT_CONTRACT: {
    label: "Aviso Importante!",
    colorScheme: "#FF0000",
    tagLabel: "A CAIXA informa que foram realizadas mudanças cadastrais na conta do FGTS, o que impede a contratação. Entre em contato com a CAIXA para regularização.",
  },
  FIDUCIARY_INSTITUTION_NO_VALID_AGREEMENT: {
    label: "Aviso Importante!",
    colorScheme: "#FF0000",
    tagLabel: "Banco sem autorização. Favor contatar o suporte.",
  },
  FIDUCIARY_INSTITUTION_NO_AUTHORIZATION: {
    label: "Aviso Importante!",
    colorScheme: "#FF0000",
    tagLabel: "Você ainda não autorizou a bancarizadora no aplicativo do FGTS. Você poderá realizar uma nova consulta em 5 minutos.",
  },
  UNEXPECTED_ERROR: {
    label: "Aviso Importante!",
    colorScheme: "#FF0000",
    tagLabel: "A CAIXA não teve sucesso na consulta. Tente novamente em 5 minutos.",
  },
  PENDING_CONFIRMATION: {
    label: "Consulta Concluída!",
    colorScheme: "yellow.400",
    tagLabel: "Sua consulta foi realizada com sucesso.",
  }
};

export function getStatusInfoFromApi(status?: string): StatusInfo {
  if (!status) {
    return {
      label: "Status não fornecido",
      colorScheme: "gray",
      tagLabel: "Não Fornecido",
    };
  }
  return (
    statusInfoMap[status] || {
      label: "Status desconhecido",
      colorScheme: "gray",
      tagLabel: "Desconhecido",
    }
  );
}
